define('rebrush/components/product/view',[
	'jquery',
	'lodash',
	'cartware/components/_base',
	'cartware/jquery/bem'
], function(
	$,
	_,
	Component,
	BEM
) {
	return Component.create({
		block:						null,

        productName:            	null,
        originalProductName:    	null,

		subheadline:				null,
		originalSubheadline:		null,

		shortDescription:			null,
		originalShortDescription:	null,

		onChangeCallback:			null,

		constructor: function() {
			this.onChangeCallback = _.bind(this._onChangeSimple, this);
		},

		$init: function() {
			this.block = BEM.block('product-view');

            this.productName = this.block.getElements('name');
            this.originalProductName = this.productName.html();

			this.shortDescription = this.block.getElements('short-description');
			this.originalShortDescription = this.shortDescription.html();

			this.subheadline = this.block.getElements('subheadline');
			this.originalSubheadline = this.subheadline.html();

			this.initializeEvents();
		},

		initializeEvents: function() {
			var currentSimple = _.get(window, 'spConfig.__currentSimple');

			$(document).on('product/changeSimple', this.onChangeCallback);
			$(document).on('product/changeGallerySimple', this.onChangeCallback);

			if (currentSimple) {
				this._onChangeSimple(null, currentSimple);
			}
		},

		_onChangeSimple: function(e, simple) {
			var productNameHtml = _.get(simple, 'product_name', this.originalProductName),
                shortDescriptionHtml = _.get(simple, 'short_description', this.originalShortDescription),
				subheadlineHtml = _.get(simple, 'subheadline', this.originalSubheadline);

			this.productName.html(productNameHtml);
            this.shortDescription.html(shortDescriptionHtml);
			this.subheadline.html(subheadlineHtml);
		},

		destructor: function() {
			$(document).off('product/changeSimple', this.onChangeCallback);
			$(document).off('product/changeGallerySimple', this.onChangeCallback);
		}
	});
});
